<template>
    <div>
      <h2>Profile</h2>
      <p>Under construction</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'UserProfile',
  };
  </script>